/* ============================================================
   Archive44 — main.js v3
   Mobile nav, product rendering, reviews, drag scroll, cart
   ============================================================ */

// ----- MOBILE NAV -----
(function () {
  var hamburger = document.getElementById('hamburger');
  var navClose = document.getElementById('navClose');
  var mobileNav = document.getElementById('mobileNav');
  var navOverlay = document.getElementById('navOverlay');

  function openNav() {
    if (mobileNav) { mobileNav.classList.add('is-open'); mobileNav.setAttribute('aria-hidden','false'); }
    if (navOverlay) navOverlay.classList.add('is-active');
    if (hamburger) hamburger.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    if (mobileNav) { mobileNav.classList.remove('is-open'); mobileNav.setAttribute('aria-hidden','true'); }
    if (navOverlay) navOverlay.classList.remove('is-active');
    if (hamburger) hamburger.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
  }
  if (hamburger) hamburger.addEventListener('click', openNav);
  if (navClose) navClose.addEventListener('click', closeNav);
  if (navOverlay) navOverlay.addEventListener('click', closeNav);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeNav(); });
})();

// ----- CART (Shopify connected) -----
(function() {
  var SHOPIFY_CART_URL = (window.Shopify.routes.root + 'cart');
  var cartCount = document.getElementById('cartCount');
  var count = cartCount ? parseInt(cartCount.getAttribute('data-count') || '0', 10) : 0;

  function updateCount() {
    if (!cartCount) return;
    cartCount.textContent = count;
    cartCount.setAttribute('data-count', count);
    cartCount.style.display = count > 0 ? 'flex' : 'none';
  }

  // Cart icon → go to Shopify cart
  var cartBtn = document.getElementById('cartBtn');
  if (cartBtn) {
    cartBtn.addEventListener('click', function() {
      if (window.ArchiveCart) window.ArchiveCart.open(cartBtn); else window.location.href = SHOPIFY_CART_URL;
    });
  }

  updateCount();
})();

// ----- DRAG SCROLL HELPER -----
function enableDragScroll(el) {
  if (!el) return;
  var isDown = false, startX, scrollLeft;
  el.addEventListener('mousedown', function(e) {
    isDown = true; el.style.cursor = 'grabbing';
    startX = e.pageX - el.offsetLeft; scrollLeft = el.scrollLeft;
  });
  el.addEventListener('mouseleave', function() { isDown = false; el.style.cursor = 'grab'; });
  el.addEventListener('mouseup', function() { isDown = false; el.style.cursor = 'grab'; });
  el.addEventListener('mousemove', function(e) {
    if (!isDown) return; e.preventDefault();
    el.scrollLeft = scrollLeft - (e.pageX - el.offsetLeft - startX) * 1.4;
  });
}

// ----- PRODUCT CARD RENDERER -----
function renderProductCard(p, isSale) {
  var price = isSale ? 99 : p.price;
  var priceHtml = isSale
    ? '<span class="product-card__price product-card__price--sale">$' + price + '</span><span class="product-card__price--original">$' + p.price + '</span>'
    : '<span class="product-card__price">$' + price + '</span>';
  var soldOut = p.inventory === 0;
  return '<a href="product.html?id=' + p.id + (isSale ? '&sale=1' : '') + '" class="product-card">' +
    '<div class="product-card__media">' +
      '<img src="' + p.images[0] + '" alt="' + p.title + '" loading="lazy">' +
      (soldOut
        ? '<span class="product-card__badge">Sold Out</span>'
        : '<span class="product-card__badge">' + p.scarcity + '</span>') +
      (isSale ? '<span class="product-card__sale-badge">$99 Sale</span>' : '') +
    '</div>' +
    '<div class="product-card__body">' +
      '<div class="product-card__rating"><span class="stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span><span class="rating-count">&nbsp;(248)</span></div>' +
      '<p class="product-card__vendor">Chrome Hearts</p>' +
      '<h3 class="product-card__title">' + p.title + '</h3>' +
      priceHtml +
    '</div>' +
  '</a>';
}

// ----- FEATURED GRID (homepage — 8 products) -----
(function () {
  var featuredGrid = document.getElementById('featuredGrid');
  if (!featuredGrid || featuredGrid.children.length || typeof PRODUCTS === 'undefined') return;
  // Pick 8 non-sale products
  var featured = PRODUCTS.filter(function(p){ return !(p.tags && p.tags.indexOf('sale') !== -1); }).slice(0, 8);
  featuredGrid.innerHTML = featured.map(function(p) { return renderProductCard(p, false); }).join('');
})();

// ----- $99 SALE GRID (homepage — 4 products) -----
(function () {
  var saleGrid = document.getElementById('saleGrid');
  if (!saleGrid || saleGrid.children.length || typeof PRODUCTS === 'undefined') return;
  var saleProducts = PRODUCTS.filter(function(p){ return p.tags && p.tags.indexOf('sale') !== -1; }).slice(0, 4);
  saleGrid.innerHTML = saleProducts.map(function(p) { return renderProductCard(p, true); }).join('');
})();

document.querySelectorAll('.reviews-scroll').forEach(enableDragScroll);

// ----- DRAG SCROLL: Editorial strip -----
(function() {
  var el = document.getElementById('editorialStrip');
  enableDragScroll(el);
})();

// ----- DRAG SCROLL: Editorial strip inner -----
(function() {
  // Also make the scroll wrap itself drag-scrollable
  var wrap = document.querySelector('.editorial-scroll-wrap');
  enableDragScroll(wrap);
})();

// ----- DRAG SCROLL: Instagram Reels strip -----
(function() {
  var wrap = document.querySelector('.reels-scroll-wrap');
  enableDragScroll(wrap);
  var strip = document.getElementById('reelsStrip');
  enableDragScroll(strip);
})();

// ----- DRAG SCROLL: Category carousel -----
(function() {
  var carousel = document.getElementById('catCarousel');
  enableDragScroll(carousel);
})();


function initArchiveSections(root) {
  root.querySelectorAll('[data-gallery-image]').forEach(function(button) {
    if (button.dataset.bound) return;
    button.dataset.bound = 'true';
    button.addEventListener('click', function() {
      var gallery = button.closest('.product-gallery');
      var image = gallery.querySelector('[data-gallery-main]');
      if (!image) return;
      image.src = button.dataset.galleryImage;
      image.removeAttribute('srcset');
      gallery.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
      button.classList.add('active');
    });
  });
}
initArchiveSections(document);
document.addEventListener('shopify:section:load', function(event) {
  initArchiveSections(event.target);
  event.target.querySelectorAll('.reviews-scroll,.editorial-scroll-wrap,.cat-carousel').forEach(enableDragScroll);
});
